import $ from 'jquery';

$(function () {
  if ($('#reporting-group-team-tree').length) {
    $('#reporting-group-team-tree #employee_ids')
      .val()
      .split(',')
      .forEach(function (id) {
        $("[data-id='" + id + "'] :checkbox")
          .prop('checked', true)
          .addClass('added');
      });
  }
});
